import React from 'react';
import TrainingCard from "../cards/trainingCards/trainingCard";
import {Thing} from "../../interfaces/course";
const ExploreAllCards = ({coursesByCat}: {coursesByCat: Thing[]} ) => {
  return (
      <div className="exploreAllCards">
          {coursesByCat && coursesByCat.map((item, index) =>
              <TrainingCard
                  key={index}
                  accelerator={item}
                  carouselTitle={'Explore All'}
                  cardWidth=""
                  locationValue={''}
                  hoverPointer={true}
                  source={'exploreAll'}
              />
          )}
      </div>
  );
}
export default ExploreAllCards;